export default class Attribute {
    public static readonly PERSON_ID = 'id';
    public static readonly USERNAME = 'username';
    public static readonly REFERRER = 'referrer';
    public static readonly SESSION_ID = 'welcome_page_session_id';
    public static readonly PREVIOUS_PAGE = 'previous_page';
}
